module.exports = __webpack_public_path__ + "img/EXTERIOR-SWIFT-BOOSTER-GREEN-2.ff966151.jpg";